import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
import config, { renderMediaQueries, resolveAlignItems, resolveJustifyContent } from './config';
import { viewports } from '../helper';

var resolveMargin = function resolveMargin() {
  return renderMediaQueries(function (dimension) {
    var gutterWidth = parseFloat(config.gutterWidth[dimension]) / 2;
    return css(["margin-left:-", "px;margin-right:-", "px;"], gutterWidth, gutterWidth);
  });
};

var resolveReverse = function resolveReverse(reverse) {
  if (!reverse) return;

  if (Array.isArray(reverse)) {
    return renderMediaQueries(function (dimension) {
      return css(["flex-direction:", ";"], reverse.indexOf(dimension) > -1 ? 'row-reverse' : 'row');
    });
  }

  return css(["flex-direction:row-reverse;"]);
};

var Root = styled.div.withConfig({
  displayName: "GridRow__Root",
  componentId: "sc-1y9oihu-0"
})(["", " display:flex;flex:1 0 auto;flex-wrap:wrap;", " ", " ", " ", ""], ScopedCssBaseline, resolveMargin(), function (_ref) {
  var reverse = _ref.reverse;
  return resolveReverse(reverse);
}, function (_ref2) {
  var align = _ref2.align;
  return resolveAlignItems(align);
}, function (_ref3) {
  var justify = _ref3.justify;
  return resolveJustifyContent(justify);
});

var GridRow = function GridRow(props) {
  return (
    /*#__PURE__*/
    React.createElement(Root, props)
  );
};

GridRow.viewports = {
  smallMobile: viewports.smallMobile,
  mobile: viewports.mobile,
  tablet: viewports.tablet,
  desktop: viewports.desktop,
  largeDesktop: viewports.largeDesktop
};
GridRow.defaultProps = {
  reverse: [],
  align: null,
  justify: null
};
process.env.NODE_ENV !== "production" ? GridRow.propTypes = {
  /**
   * reverses the direction of the row
   */
  reverse: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),

  /**
   * align the content vertically
   */
  align: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /**
   * align the content horizontally
   */
  justify: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /**
   * content
   */
  children: PropTypes.node,

  /**
   * enables debug
   */
  debug: PropTypes.bool
} : void 0;
export default GridRow;